import { Grid, Typography } from '@mui/material';
import { TitledPaper } from 'cleveron-web-components';
import React from 'react';

import Module from './Module';

function Maintenance({ disabled, id, modules, issueId }) {
    return (
        <TitledPaper id={id} titleKey="task.maintenance">
            <Grid container spacing={2}>
                {modules?.map(module => (
                    <Grid item key={module.name} xs={12}>
                        <Module
                            disabled={disabled}
                            id={`${id}Module`}
                            issueId={issueId}
                            module={module}
                        />
                    </Grid>
                ))}
            </Grid>
            {!modules.length && (
                <Typography color="textSecondary" mt={2} variant="body2">
                    No maintenance items yet
                </Typography>
            )}
        </TitledPaper>
    );
}
export default Maintenance;
